import { pages } from '../../utils/common';
import { IAppNavigationMenuItem } from './components.interfaces';

const generateNavigationItem = (pageItem: any): IAppNavigationMenuItem => {
  return {
    title: pageItem.title,
    ...(pageItem.icon && { icon: pageItem.icon }),
    pageToNavigate: pageItem.path,
    ...(pageItem?.subPages && {
      subPages: Object.values(pageItem.subPages).map(generateNavigationItem),
    }),
  };
};

export const getPrimaryNavigation = (): IAppNavigationMenuItem[] => {
  return [
    generateNavigationItem(pages.dashboard),
    generateNavigationItem(pages.students),
    generateNavigationItem(pages.staff),
    generateNavigationItem(pages.academics),
    generateNavigationItem(pages.communications),
    generateNavigationItem(pages.finance),
    generateNavigationItem(pages.analytics),
    generateNavigationItem(pages.administration),
    generateNavigationItem(pages.users),
    generateNavigationItem(pages.settings),
  ];
};

export const getSecondaryNavigation = (): IAppNavigationMenuItem[] => {
  return [
    generateNavigationItem(pages.profile),
    generateNavigationItem(pages.logout),
  ];
};
